export default [{
  title: 'Demandas Audiovisual',
  icon: 'LayersIcon',
  route: 'audiovisual-demands-job-type',
  roles: ['permission.audiovisual.demands.period.view']
}]